import * as api from "~/api";

export const upgradeLegacyTokenApi = (baseUrl, config = {}) => {
  return api.postHttpRequestAsync(
    `${baseUrl}/user/upgrade-legacy-token`,
    {},
    config
  );
};

export const refreshTokenApi = (baseUrl, data = {}, config = {}) => {
  return api.postHttpRequestAsync(
    `${baseUrl}/user/refresh-token`,
    data,
    config
  );
};

export const loginWithPasswordMedproIDApi = (
  baseUrl,
  data = {},
  config = {}
) => {
  return api.postHttpRequestAsync(
    `${baseUrl}/user/medpro-login-password-cskh`,
    data,
    config
  );
};

export const logoutSession = (baseUrl, data = {}, config = {}) => {
  return api.postHttpRequestAsync(`${baseUrl}/user/logout`, data, config);
};

